import { combineReducers } from 'redux';
import fileUploadSlice from 'reducers/fileUploadSlice';
import globalSlice from 'reducers/globalSlice';
import laancSlice from 'reducers/laancSlice';
import uspaceSlice from 'reducers/uspaceSlice';
import manageTablesSlice from 'reducers/manageTablesSlice';
import mapSlice from 'reducers/mapSlice';
import reportsSlice from 'reducers/reportsSlice';
import rolesSlice from 'reducers/rolesSlice';
import userAuthSlice from 'reducers/userAuthSlice';
import streamingSlice from 'reducers/streamingSlice';
import liveTrafficSlice from 'reducers/liveTrafficSlice';
import operatingPictureSlice from 'reducers/operatingPictureSlice';
import flightPathViewerSlice from 'reducers/flightPathViewerSlice';
import activitiesSlice from 'reducers/activitiesSlice';
import opsViewSlice from 'reducers/opsViewSlice';
import { opsViewDetailsUrl } from 'components/opsView/opsViewUtils';

const appReducer = combineReducers({
	fileUpload: fileUploadSlice,
	global: globalSlice,
	laanc: laancSlice,
	uspace: uspaceSlice,
	manageTables: manageTablesSlice,
	map: mapSlice,
	reports: reportsSlice,
	roles: rolesSlice,
	streaming: streamingSlice,
	userAuth: userAuthSlice,
	liveTraffic: liveTrafficSlice,
	operatingPicture: operatingPictureSlice,
	flightPathViewer: flightPathViewerSlice,
	activities: activitiesSlice,
	opsView: opsViewSlice
});

const rootReducer = (state, action) => {
	if (action.type === 'HYDRATE_REDUX' && window.location.pathname.includes(opsViewDetailsUrl)) {
		return {
			...state,
			liveTraffic: { ...action.payload.liveTraffic },
			operatingPicture: { ...action.payload.operatingPicture },
			streaming: { ...action.payload.streaming },
			opsView: { ...action.payload.opsView, stateHydrated: true },
			map: { ...action.payload.map }
		};
	}
	return appReducer(state, action);
};

export default rootReducer;
